var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFreeze = function SvgFreeze(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Freeze"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path247",
    d: "M9.5 1V6.33333M9.5 6.33333L6.9819 7.66648M9.5 6.33333L12.0181 7.66648M12.4069 2.06682L9.5 4.1997L6.59313 2.06682M1.94652 5.00019L6.9819 7.66648M6.9819 7.66648V10.3335M4.40687 3.2239L4.96808 6.59966L1.5 7.84329M1.94652 12.9998L6.9819 10.3335M6.9819 10.3335L9.5 11.6667M1.5 10.1567L4.96808 11.3996L4.40687 14.7761M9.5 17V11.6667M9.5 11.6667L12.0181 10.3335M6.59313 15.9332L9.5 13.7996L12.4069 15.9332M17.0535 12.9998L12.0181 10.3335M12.0181 10.3335V7.66648M14.5931 14.7761L14.0319 11.3996L17.5 10.1567M17.0535 5.00019L12.0181 7.66648M17.5 7.84329L14.0319 6.59966L14.5931 3.2239",
    stroke: "currentColor",
    strokeWidth: 1.27067,
    strokeMiterlimit: 34.043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgFreeze;